"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DynamicFunnelChart = void 0;
var _CommonUtility = require("../../../../utils/CommonUtility.js");
var _react = _interopRequireWildcard(require("react"));
var _themeProvider = require("../../../../theme/themeProvider/index.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// const FunnelChartComponent = (props: Iprops) => {
// 	const {
// 		width = 300,
// 		height = 200,
// 		data = [],
// 		dataKey, //X axis label. Usually an object's property
// 		chartDataKey, //Based on this data, graphs will appear.  Usually an object's property
// 		tooltipStatus = true,
// 		customTooltip,
// 	} = props;
// 	const calculatePercentage = currentValue => {
// 		const total = data.reduce((prevValue: number, currentValue: IDynamicValue) => {
// 			if (typeof currentValue[chartDataKey] === 'number') return prevValue + Number(currentValue[chartDataKey]);
// 			return prevValue;
// 		}, 0);
// 		const percentage = currentValue / total;
// 		const currentWidth = percentage * Number(width);
// 		return currentWidth;
// 	};
// 	const getTrapezoids = (): FunnelTrapezoidItem[] => {
// 		const items: FunnelTrapezoidItem[] = [];
// 		for (const chartData of data) {
// 			const calculatedWidth = calculatePercentage(chartData[chartDataKey]);
// 			const trapezoidsItem: FunnelTrapezoidItem = {
// 				x: 0,
// 				y: 0,
// 				upperWidth: calculatedWidth,
// 				lowerWidth: calculatedWidth - 20,
// 				height: 80,
// 			};
// 			items.push(trapezoidsItem);
// 		}
// 		return items;
// 	};
// 	return (
// 		<ResponsiveContainer width={width} height={height}>
// 			<FunnelChart>
// 				{tooltipStatus && <Tooltip content={customTooltip} />}
// 				<Funnel
// 					dataKey={chartDataKey}
// 					nameKey={chartDataKey}
// 					data={data}
// 					isAnimationActive
// 					trapezoids={getTrapezoids()}
// 				>
// 					<LabelList position="right" fill="#000" stroke="none" dataKey={dataKey} />
// 				</Funnel>
// 			</FunnelChart>
// 		</ResponsiveContainer>
// 	);
// };

// export default FunnelChartComponent;

const FunnelChartComponent = props => {
  const [uuid] = (0, _react.useState)((0, _CommonUtility.generateUuidv4)());
  const theme = (0, _themeProvider.useTheme)();
  const {
    width = 400,
    height = 200,
    data = [],
    dataKey,
    //X axis label. Usually an object's property
    chartDataKey,
    //Based on this data, graphs will appear.  Usually an object's property
    tooltipStatus = true,
    customTooltip,
    barColor = theme.color.primary,
    colorFade
  } = props;
  const chartHeight = Number(height);

  // Calculate the y-coordinate for each trapezoid's top and bottom points
  const yScale = value => chartHeight / 100 * value;
  const yTop = index => chartDataKey ? yScale(data[index][chartDataKey]) : 0;
  const yBottom = index => chartDataKey ? yScale(data[index][chartDataKey] - 20) : 0; // Adjust the difference for trapezoid height

  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    width: width,
    height: height,
    children: data.map((entry, index) => {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(DynamicFunnelChart, Object.assign({
        entry: entry,
        index: index,
        barColor: barColor,
        height: height,
        width: width
      }, props), `${uuid}-trapezoid-${index}`);
    })
  });
};
const DynamicFunnelChart = funnelChartProps => {
  const {
    chartDataKey,
    width,
    entry,
    data,
    height,
    index,
    colorFade,
    barColor,
    dataKey
  } = funnelChartProps;
  const polygonRef = (0, _react.useRef)(null);
  const startTextRef = (0, _react.useRef)(null);
  const endTextRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (!polygonRef.current) return;
    if (!startTextRef.current) return;
    if (!endTextRef.current) return;
    const polygon = polygonRef.current;
    const startText = startTextRef.current;
    const endText = endTextRef.current;

    // Get the points attribute of the polygon
    const points = polygon.getAttribute('points');
    const pointsData = polygonRef.current.points;
    const pointsArray = [];
    for (const pointData of pointsData) {
      pointsArray.push([pointData.x, pointData.y]);
    }
    // Find the min and max x-coordinates and calculate the vertical center
    let minX = Infinity;
    let maxX = -Infinity;
    let centerY = 0;
    pointsArray.forEach(([x, y]) => {
      const parsedX = parseFloat(String(x));
      const parsedY = parseFloat(String(y));
      if (parsedX < minX) minX = parsedX;
      if (parsedX > maxX) maxX = parsedX;
      centerY += parsedY;
    });
    centerY /= pointsArray.length;

    // Position the text elements at the start and end of the polygon
    if (startText) {
      startText.setAttribute('x', (minX + 60).toString());
      startText.setAttribute('y', centerY.toString());
    }
    if (endText) {
      endText.setAttribute('x', (maxX - 60).toString());
      endText.setAttribute('y', centerY.toString());
    }
  }, [polygonRef.current, startTextRef.current, endTextRef.current]);
  const getMaxValue = (0, _react.useMemo)(() => {
    let value = 0;
    for (const graphData of data) {
      if (chartDataKey && chartDataKey in graphData && value < graphData[chartDataKey]) value = graphData[chartDataKey];
    }
    return value;
  }, [data]);
  const maxValue = getMaxValue;
  const calculateWidth = currentValue => {
    // const total = data.reduce((prev: number, curr: { value: number }) => {
    // 	return prev + curr.value;
    // }, 0);
    const total = maxValue;
    const percentage = currentValue / total;
    const currentWidth = percentage * Number(width);
    return currentWidth / 2;
  };
  const calculateHeight = () => {
    const calculatedHeight = Number(height) / data.length;
    if (calculatedHeight > 40) return 40;
    return calculatedHeight;
  };
  if (!chartDataKey || !(chartDataKey in entry)) return null;
  const x = Number(width) / 2;
  let calculatedWidth = calculateWidth(chartDataKey ? entry[chartDataKey] : 0);
  if (calculatedWidth < 30) calculatedWidth = 30;
  const halfTopWidth = calculatedWidth - 20; // Customize the top width of the trapezoid
  const halfBottomWidth = calculatedWidth - 0; // Customize the bottom width of the trapezoid
  const calculatedHeight = calculateHeight();
  const indexData = calculatedHeight * (data.length - index);
  let colorFadeOpacity = 1;
  if (colorFade) colorFadeOpacity = colorFadeOpacity - 0.05 * index;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
      ref: polygonRef,
      points: `
					 ${x - halfTopWidth},${indexData}
					  ${x + halfTopWidth},${indexData}
					  ${x + halfBottomWidth},${indexData - calculatedHeight}
					  ${x - halfBottomWidth},${indexData - calculatedHeight}
	`,
      fill: `${barColor}`,
      strokeWidth: 6,
      strokeLinejoin: "round",
      stroke: "#fff",
      strokeLinecap: "round",
      fillOpacity: colorFadeOpacity
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
      ref: startTextRef,
      id: "startText",
      fill: '#fff',
      fontSize: '14px',
      textAnchor: "middle" // Center the text horizontally
      ,
      alignmentBaseline: "middle",
      children: dataKey && dataKey in entry ? entry[dataKey] : ''
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("text", {
      ref: endTextRef,
      id: "endText",
      fill: '#fff',
      fontSize: '14px',
      textAnchor: "middle" // Center the text horizontally
      ,
      alignmentBaseline: "middle",
      children: 'subLabel' in entry ? entry['subLabel'] : ''
    })]
  });
};
exports.DynamicFunnelChart = DynamicFunnelChart;
var _default = exports.default = FunnelChartComponent;